/**
* Convert To Html
*/
export function convertToHtml(str) {
  if (str) {
    return str?.replace(/&quot;/g, '"')
      ?.replace(/&gt;/g, '>')
      ?.replace(/&lt;/g, '<')
      ?.replace(/&amp;/g, '&')
  }
}

/**
* Parse Flat Url Params
*/
export function parseFlatParams(url) {
  const result = {}

  const query = url?.split('?')[1]
  if (!query) return result

  const params = new URLSearchParams(query)

  for (const [key, value] of params.entries()) {
    result[key] = value || null
  }

  return result
}

/**
* Parse Url Params
*/
export function parseUrlParams(url) {
  const result = {
    basePath: '',
    params: {},
    filters: {}
  }

  const [path, query] = url.split('?')
  result.basePath = path

  if (!query) return result

  const searchParams = new URLSearchParams(query)

  for (const [key, value] of searchParams.entries()) {
    const decodedValue = value || null

    const filterMatch = key.match(/^filters\[(.+?)\]$/)
    if (filterMatch) {
      result.filters[filterMatch[1]] = decodedValue
    } else {
      result.params[key] = decodedValue
    }
  }

  return result
}
    
/**
* Object To Url Params
*/
export function objectToUrlParams (obj) {
  const params = []

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== '') {
      if (typeof obj[key] === 'object') {
        for (const subKey in obj[key]) {
          if (Object.prototype.hasOwnProperty.call(obj[key], subKey) && obj[key][subKey] !== '') {
            params.push(`${encodeURIComponent(key)}[${encodeURIComponent(subKey)}]=${encodeURIComponent(obj[key][subKey])}`)
          }
        }
      } else {
        params.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
      }
    }
  }

  return params.join('&')
}

  
/*
* Filter Non Empty Params
*/
export function filterNonEmptyParams (params) {
  return Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined && _)
  )
}

/**
* Merge Objects
*/
export function deepMergeObjects (obj1, obj2)  {
  const result = { ...obj1 }

  for (const key in obj2) {
    if (obj2.hasOwnProperty(key)) {
      if (
        typeof obj2[key] === 'object' &&
          obj2[key] !== null &&
          !Array.isArray(obj2[key])
      ) {
        result[key] = deepMergeObjects(obj1[key] || {}, obj2[key])
      } else {
        result[key] = obj2[key]
      }
    }
  }

  return result
}

/*
* FormData field to  Boolean
*/
export function toBoolean (value) {
  return value === '1' || value === 1 || value === 'true' || value === true ? 1 : 0
}

/**
* Get Est. Ship Date
*/
export function getEstShipDate (data) {
  class GetShipOrderDate {
    constructor () {
      this.baseCutoffTime = {
        hour: data.cutOffTime.hrs,
        min: data.cutOffTime.min
      }
    }

    /**
    * Get Current Chicago Date
    */
    getChicagoDate = () => {
      const d = new Date()
      const localTime = d.getTime()
      const localOffset = d.getTimezoneOffset() * 60 * 1000
      const utcTime = localTime + localOffset

      // Get time zone offset for Chicago, USA
      const getOffset = () => {
        const stdTimezoneOffset = function () {
          const jan = new Date(0, 1)
          const jul = new Date(6, 1)
          return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset())
        }

        const today = new Date()

        const isDstObserved = function (today) {
          return today.getTimezoneOffset() < stdTimezoneOffset()
        }

        if (isDstObserved(today)) {
          return -5
        } else {
          return -6
        }
      }

      // obtain and add destination's UTC time offset
      const offset = getOffset()
      const usa = utcTime + (60 * 60 * 1000 * offset)

      // convert msec value to date string
      const chicagoDate = new Date(usa)

      return new Date(chicagoDate)
    }

    /**
      * Set Timer
      */
    setTimer = () => {
      const cutoffTime = this.getChicagoDate()
      const chicagoTime = new Date(cutoffTime.getTime())

      if (cutoffTime.getHours() > this.baseCutoffTime.hour || (cutoffTime.getHours() === this.baseCutoffTime.hour && cutoffTime.getMinutes() >= this.baseCutoffTime.min)) {
        cutoffTime.setDate(cutoffTime.getDate() + 1)
      }
        
      cutoffTime.setHours(this.baseCutoffTime.hour, this.baseCutoffTime.min, 0, 0)
      const distance = cutoffTime - chicagoTime.getTime()

      // Time calculations for days, hours, minutes and seconds
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((distance % (1000 * 60)) / 1000)

      // If the count down is finished, write some text
      if (hours <= 0 && minutes <= 0 && seconds <= 0) {
        return '---'
      }

      // Display the result in the element with id="demo"
      return hours + 'h ' + minutes + 'm ' + seconds + 's '
    }
  }

  /**
  * Init Timer
  */
  const getShipOrderDate = new GetShipOrderDate()

  if (data.timeRestrictionsArr?.optionsEstShipDate) {
    return {
      time: getShipOrderDate.setTimer(),
      date: data.isShort ? data.timeRestrictionsArr?.optionsEstShipDateShort[data.timeRestriction] : data.timeRestrictionsArr?.optionsEstShipDate[data.timeRestriction]
    }
  }

  return false
}

/*
* Create Hash
*/
import hash from 'hash.js'

export function hashKey(input, length = 16) {
  const json = JSON.stringify(input)
  const fullHash = hash.sha256().update(json).digest('hex')
  return fullHash.slice(0, length)
}